import React from "react";
import Icon from "../../../components/ui/Icon";
import { getOrderStatus } from "../../../helpers/order.helper";
import {
  Hero,
  TopRow,
  NavButton,
  CancelButton,
  IconBadge,
  IconBadgeInner,
  Title,
  OrderBadge,
} from "./OrderHeader.styles";
import { formatBRL } from "../../../helpers/currency.helper";

interface OrderHeaderProps {
  saleId?: string;
  document?: number;
  status: string;
  total: number;
  onGoHome: () => void;
  showCancelButton: boolean;
  onOpenCancelModal: () => void;
}

export default function OrderHeader({
  saleId,
  document,
  status,
  total,
  onGoHome,
  showCancelButton,
  onOpenCancelModal,
}: OrderHeaderProps) {
  return (
    <Hero>
      <TopRow>
        <NavButton type="button" onClick={onGoHome}>
          Voltar ao cardápio
        </NavButton>
        {showCancelButton && (
          <CancelButton type="button" onClick={onOpenCancelModal}>
            Cancelar
          </CancelButton>
        )}
      </TopRow>

      <IconBadge>
        <IconBadgeInner>
          <Icon name="check" size={26} color="#16B877" strokeWidth={3} />
        </IconBadgeInner>
      </IconBadge>

      <Title>{getOrderStatus(status)}</Title>

      <OrderBadge>
        Pedido {document != null ? `#${document}` : `#${saleId}`} · {formatBRL(total)}
      </OrderBadge>
    </Hero>
  );
}
